import React, { useContext, useEffect } from "react";
import Clients from "../clients/Clients";
import ClientForm from "../clients/ClientForm";
import ClientFilter from "../clients/ClientFilter";
import AuthContext from "../../context/auth/authContext";

const ClientsPage = () => {
  const authContext = useContext(AuthContext);

  const { user } = authContext;

  useEffect(() => {
    authContext.loadUser();
    //eslint-disable-next-line
  }, []);

  if (user && ["admin"].indexOf(user.role) !== -1) {
    return (
      <div className="grid-2">
        <div>
          <ClientForm />
        </div>
        <div>
          <ClientFilter />
          <Clients />
        </div>
      </div>
    );
  } else {
    return <div>{/* <h1>Not Authorized</h1> */}</div>;
  }
};

export default ClientsPage;
